<template>
  <div class="company-info" :style="warpperStyle">
    <div class="invoice_nav">
      <navbar
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="title">查看支付宝账户</div>
    <div class="content">
      <div class="invoice_info">
        <van-row>
          <van-col span="24"
            >支付宝账户<span>{{ companyInfo.account_number }}</span></van-col
          >
          <van-col span="24"
            >账户名称<span>{{ companyInfo.account_name }}</span></van-col
          >
          <van-col span="24"
            >认证状态
            <span class="status1" v-if="companyInfo.status == 1">已认证</span>
            <span class="status2" v-if="companyInfo.status == 2">已驳回</span>
            <span class="status3" v-if="companyInfo.status == 0">审核中</span>
          </van-col>
          <van-col span="24" class="last" @click="change"
            >修改信息<span><van-icon name="arrow" /></span
          ></van-col>
        </van-row>
      </div>
    </div>
    <div v-if="companyInfo.status == 2" class="reason">
      <div class="label">驳回原因</div>
      <div class="desc">{{ companyInfo.remark }}</div>
    </div>
    <div class="complete" :style="completeStyle">
      <van-button @click="goBack" type="primary" class="operation_btn"
        >确定</van-button
      >
      <div class="complete-empty"></div>
    </div>
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
export default {
  data() {
    return {
      companyInfo: {},
      warpperStyle: { height: "100%" },
      completeStyle: { bottom: "0" },
      lefticon: require("@/assets/accountAgent/common/back.png"),
    };
  },
  components: {
    navbar,
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api
        .post("member-relation/member/supplier/alipay/detail")
        .then((res) => {
          this.companyInfo = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    change() {
      this.$router.push("/purchaseSupplier/changeBind");
    },
  },
};
</script>


<style lang="less" scoped>
.company-info {
  overflow-x: hidden;
  padding: 8.8rem 0 5rem;
  box-sizing: border-box;
  color: #333;
  font-size: 1.4rem;
  background: #f5f6f7;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
  }
  .title {
    height: 6rem;
    line-height: 6rem;
    color: #333;
    font-size: 2rem;
    font-weight: 700;
    padding: 0 1.6rem;
  }
  .content {
    padding: 0 1.6rem;
    position: relative;

    .invoice_info {
      min-height: 21.6rem;
      background: #fff;
      border-radius: 0.8rem;
      padding: 0 1.6rem;
      box-sizing: border-box;

      .van-col {
        color: #333;
        font-size: 1.4rem;
        font-weight: 700;
        height: 5.35rem;
        line-height: 5.35rem;
        border-bottom: solid 0.05px #eeeeee;

        span {
          font-weight: 400;
          float: right;

          .van-icon {
            color: #e3e3e3;
          }
        }

        .status1 {
          color: #fb6c10;
        }

        .status2 {
          color: #ff4f4f;
        }

        .status3 {
          color: #70a9ff;
        }
      }

      .last {
        border: none;
      }
    }
  }
  .complete {
    position: fixed;
    // bottom: 0;
    padding: 0 12px;
    // width: calc(100% - 24px);
    box-sizing: border-box;
    width: 100%;
    transition: bottom 0.1s linear;
    .complete-empty {
      height: 4px;
      width: 100%;
    }
    .operation_btn {
      color: #fff;
      border: none;
      width: 100%;
      margin: 0 auto;
      height: 44px;
      font-size: 16px;
      display: block;
      border-radius: 22px;
      line-height: 44px;
      font-weight: 600;
      background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
      /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to right, #fc740c, #f41a3c);
      /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
      /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #fc740c, #f41a3c);
    }
  }
  .van-uploader__preview-delet {
    font-size: 26px;
  }

  .tip {
    padding: 0 10px;
    text-align: left;
  }
  .tipL {
    margin-bottom: 24px;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  .reason {
    padding: 17px 16px;
    background: #fff;
    border-radius: 8px;
    margin: 12px 16px 0;

    .label {
      font-size: 1.4rem;
      font-weight: 700;
    }

    .desc {
      color: #ff4f4f;
      font-size: 12px;
      margin-top: 12px;
    }
  }
}
</style>





